import request from '@/utils/request';

export function submitShare(shareEid) {
    return request({
        url: `/shares/flow/${shareEid}/submit`,
        method: 'put'
    });
}

export function flowAudit(shareEid) {
    return request({
        url: `/shares/flow/${shareEid}/audit`,
        method: 'put'
    });
}

export function flowBack(shareEid, data) {
    return request({
        url: `/shares/flow/${shareEid}/back`,
        method: 'put',
        data: data
    });
}

export function deleteShare(shareEid) {
    return request({
        url: `/shares/flow/${shareEid}`,
        method: 'delete'
    });
}